import { raise } from "@cartographerio/util";
import { MotdStatus } from "./ui/components/MotdBanner";
import { optEnvvar } from "./util/envvar";

export const DEFAULT_TERRAIN_MAP_STYLE: string =
  import.meta.env.VITE_MAP_TERRAIN_STYLE ??
  import.meta.env.STORYBOOK_MAP_TERRAIN_STYLE ??
  raise(new Error("Default terrain map style not configured"));

export const DEFAULT_SATELLITE_MAP_STYLE: string =
  import.meta.env.VITE_MAP_SATELLITE_STYLE ??
  import.meta.env.STORYBOOK_MAP_SATELLITE_STYLE ??
  raise(new Error("Default satellite map style not configured"));

export const DEFAULT_PAGE_SIZE = 25;

// 3 is react query's default
export const QUERY_RETRY_COUNT = 3;

// In milliseconds
export const STRIPE_SUBSCRIPTION_UPDATE_MAX_TIMEOUT = 30000;

export const MOTD_BANNER_TEXT = optEnvvar("VITE_MOTD_BANNER_TEXT");
const rawMotdBannerStatus = optEnvvar("VITE_MOTD_BANNER_STATUS");
export const MOTD_BANNER_STATUS = ["warning", "error"].includes(
  rawMotdBannerStatus as string
)
  ? (rawMotdBannerStatus as MotdStatus)
  : null;
